export default __webpack_public_path__ + "static/media/myfull01.d55bf207.png";